<template>
  <div class="home-section4">
    <div class="section4-items" v-for="item in renderList" :key="item.title">
      <div class="item-title">
        <div class="color-line1"></div>
        <div class="color-line2"></div>
        <div>
          <img :src="item.iconPath" :alt="item.title" />
          <span>{{ item.title }}</span>
        </div>
        <div @click="item.handleMore">
          <span>查看更多</span>
          <img
            src="../../../assets/image/home-inform-icon2.png"
            alt="查看更多"
          />
        </div>
      </div>
      <div class="item-split"></div>
      <div class="item-first" @click="item.handleItem(item.list[0])">
        <img
          v-if="item.list[0]"
          :src="item.list[0].infoImg"
          :alt="item.list[0].infoName"
        />
        <div v-if="item.list[0]">{{ item.list[0].infoName }}</div>
      </div>
      <div class="item-list">
        <div
          v-for="(sub, index) in item.list.slice(1)"
          :key="index"
          @click="item.handleItem(sub)"
        >
          <div class="points"></div>
          <div>
            <div>{{ sub.infoName }}</div>
            <div v-if="sub.publishTime">
              {{ sub.publishTime.slice(0, 10) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as API from '../../../api/home/index'
export default {
  name: 'HomeSection4',
  data() {
    return {
      policyList: [],
      signupList: [],
      trainingList: []
    }
  },
  computed: {
    renderList: function () {
      return [
        {
          title: '政策文件',
          iconPath: require('../../../assets/image/home-policy-icon.png'),
          list: this.policyList,
          handleMore: this.handlePolicyMore,
          handleItem: this.handlePolicyItem
        },
        {
          title: '报名指南',
          iconPath: require('../../../assets/image/home-signup-icon.png'),
          list: this.signupList,
          handleMore: this.handleSignupMore,
          handleItem: this.handleSignupItem
        },
        {
          title: '考培资源',
          iconPath: require('../../../assets/image/home-training-icon.png'),
          list: this.trainingList,
          handleMore: this.handleTrainingMore,
          handleItem: this.handleTrainingItem
        }
      ]
    }
  },
  created() {
    this.getPolicyList()
    this.getSignupList()
    this.getTrainingList()
  },
  methods: {
    // 获取政策文件列表
    async getPolicyList() {
      try {
        const params = {
          page: 1,
          limit: 5,
          classifyId: 3
        }
        const res = await API.getListPublic(params)
        const {
          code,
          data: { records = [] }
        } = res
        if (code === 0) {
          this.policyList = records
        }
      } catch (error) {}
    },
    // 政策文件查看更多
    handlePolicyMore() {
      this.$router.push({
        path: '/publicInformationList',
        query: { classifyId: 3 }
      })
    },
    // 政策文件查看单条
    handlePolicyItem(row) {
      const { id } = row
      this.$router.push({
        path: '/publicInformationDetail',
        query: { classifyId: 3, id }
      })
    },
    // 报名指南列表
    async getSignupList() {
      try {
        const params = {
          page: 1,
          limit: 5,
          classifyId: 4
        }
        const res = await API.getListPublic(params)
        const {
          code,
          data: { records = [] }
        } = res
        if (code === 0) {
          this.signupList = records
        }
      } catch (error) {}
    },
    // 报名指南查看更多
    handleSignupMore() {
      this.$router.push({
        path: '/publicInformationList',
        query: { classifyId: 4 }
      })
    },
    // 报名指南查看单条
    handleSignupItem(row) {
      const { id } = row
      this.$router.push({
        path: '/publicInformationDetail',
        query: { classifyId: 4, id }
      })
    },
    // 考培资源文件列表
    async getTrainingList() {
      try {
        const params = {
          page: 1,
          limit: 5,
          classifyId: 5
        }
        const res = await API.getListPublic(params)
        const {
          code,
          data: { records = [] }
        } = res
        if (code === 0) {
          this.trainingList = records
        }
      } catch (error) {}
    },
    // 考培资源查看更多
    handleTrainingMore() {
      this.$router.push({
        path: '/publicInformationList',
        query: { classifyId: 5 }
      })
    },
    // 考培资源查看单条
    handleTrainingItem(row) {
      const { id } = row
      this.$router.push({
        path: '/publicInformationDetail',
        query: { classifyId: 5, id }
      })
    }
  }
}
</script>
<style scoped lang='scss'>
.home-section4 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 70px;
  .section4-items {
    width: 378px;
    height: 320px;
    background: #ffffff;
    box-shadow: 0px 0px 3px 2px #f2f2f2;
    .item-title {
      width: 378px;
      height: 54px;
      background: linear-gradient(0deg, #ffffff 0%, #ecebeb 100%);
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .color-line1 {
        position: absolute;
        width: 360px;
        height: 2px;
        background: #085dc8;
        opacity: 0.35;
        top: 0;
        left: 18px;
      }
      .color-line2 {
        position: absolute;
        width: 128px;
        height: 4px;
        background: #ff4e4e;
        top: 0;
        left: 18px;
      }

      > div:nth-child(3) {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;

        > img {
          width: 24px;
          height: 24px;
          margin: 0 13px 0 18px;
        }
      }

      > div:last-child {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        cursor: pointer;

        > img {
          width: 18px;
          height: 18px;
          vertical-align: middle;
          margin: 0 15px 0 3px;
        }
      }
    }
    .item-split {
      width: 342px;
      border-bottom: 1px dashed #c6c6c6;
      opacity: 0.7;
      margin: 0 auto;
    }
    .item-first {
      margin-top: 9px;
      height: 92px;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      cursor: pointer;
      > img {
        width: 160px;
        height: 100%;
        margin: 0 20px 0 18px;
      }
      > div {
        flex: 1;
        max-height: 100%;
        margin-right: 18px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
        display: -webkit-box;//谷歌
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;//显示几行
        overflow: hidden;
      }
    }
    .item-list {
      width: 378px;

      // 每行
      > div {
        cursor: pointer;
        width: 378px;
        height: 35px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        cursor: pointer;

        .points {
          width: 4px;
          height: 4px;
          background: #ff4e4e;
          border-radius: 50%;
          margin: 0 4px 0 8px;
        }

        // 文字 时间
        > div:last-child {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-right: 18px;
          border-bottom: 1px dashed #c6c6c6;

          // 文字
          > div:first-child {
            width: 219px;
            margin-right: 33px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
          }

          // 时间
          > div:last-child {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #666666;
          }
        }
      }
    }
  }
}
</style>
